export interface Customer {
  customerUuid: string;
  name: string;
  stpNumber: string;
  features: {
    effectiveDate: string;
    expirationDate: string;
    featureCode: string;
    featureName: string;
  }[];
}

export interface BusinessUnit {
  buName: string;
  buHierarchyPath?: string;
  buUuid: string;
  parentBusinessUnit: BusinessUnit;
}

export interface Identity {
  profile?: {
    avatar: string;
    catalogCoreCountry?: { iso2Code: string };
    homeCoreLocation?: { country: string };
    pronoun?: string;
    work1CoreLocation?: {
      locationName: string;
      country: string;
      city: string;
      state: string;
    };
  };
  dateOfBirth: string;
  nonFedFlag?: boolean;
  nonCredFlag?: boolean;
  uniqueId: string;
  email: string;
  id: string;
  identityUuid: string;
  preferredName: string;
  firstName: string;
  lastName: string;
  language?: string;
  jobTitle?: string;
  isManager?: boolean;
  manager?: Identity;
  businessUnit?: BusinessUnit;
  customer?: Customer;
  segmentOfficelocation?: string;
  identityHierarchyPath?: string;
}

export enum FieldTypes {
  EmailAddress = 'EMAIL_ADDRESS',
  BusinessUnit = 'BUSINESS_UNIT',
  LeaderName = 'LEADER_NAME',
  EmployeeId = 'EMPLOYEE_ID',
  ParentBusinessUnit = 'PARENT_BUSINESS_UNIT',
  JobTitle = 'JOB_TITLE',
  WorkLocation = 'WORK_LOCATION',
  WorkLocationCondensed = 'WORK_LOCATION_CONDENSED',
}

export enum FieldNames {
  EmailAddress = 'Email address',
  BusinessUnit = 'Business unit',
  LeaderName = 'Leader name',
  EmployeeId = 'Employee ID',
  ParentBusinessUnit = 'Parent Business Unit',
  JobTitle = 'Job Title',
  WorkLocation = 'Work Location',
  WorkLocationCondensed = 'Work Location (Condensed)',
}

export interface CustomSearchFields {
  enabled: boolean;
  fieldName: string;
  fieldType: FieldTypes;
  order: number;
  translationStringId: string;
}

export interface IdentityInfoProps {
  identity: Identity;
  color?: 'primary' | 'secondary';
  isMobile?: boolean;
  customSearchFields?: CustomSearchFields[];
  pronounsEnabled?: boolean;
}
